import React, {Component} from 'react';
import WaitingModal from '../../generics/WaitingModal';
import SearchBar from '../../generics/SearchBar';
import {translate} from 'react-i18next';
import { Table, Button } from 'react-bootstrap';
import { pencil2 } from 'react-icons-kit/icomoon/pencil2';
import { search } from 'react-icons-kit/icomoon/search';
import Moment from 'react-moment';
import { download3 } from 'react-icons-kit/icomoon/download3';
import { cross } from 'react-icons-kit/icomoon/cross';
import swal from 'sweetalert';
import ModalShippingDetails from './modalDetailsShipping';
import {print} from 'react-icons-kit/fa/print';
import ModalView from '../modalView';
import ModalStatus from '../modalStatus';
import SvgIcon from 'react-icons-kit';
import { MapsTransferWithinAStation } from 'material-ui/svg-icons';
import moment from 'moment';
import Help from '../../generics/help';
import { getColumnsList, htmlTemplates, lookupsOrderBy, unitExportDelete, unitExportSearch, unitRequestSearch } from '../../../libs/services';

var Config = require('../../../config');
const $ = require('jquery');

class Shippings extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.createShipping = this.createShipping.bind(this);
		this.onSearch_send = this.onSearch_send.bind(this);
		this.onSearch_despatch = this.onSearch_despatch.bind(this);
		this.openReport = this.openReport.bind(this);
		this.onSearch = this.onSearch.bind(this);

		var aux_date = new Date();
		var date = aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2);

		this.state = {
			submenu: "",
			results_send: [],
			results_despatch:[],
			filterText:"",
			start_date:date,
			end_date:date,
			start_folio:"",
			end_folio:"",
			option:"ENVIADO",
			columns:[],
			returnReasons:[],
			closeConfirm:false
		}
	}

	async componentDidMount(){
		var submenu = this.state.submenu === "" ? this.props.match.path.replace('/', '') : this.state.submenu;
		this.setState({
			submenu: submenu
		});
		
		var response = await getColumnsList('UNIT_EXPORT');
		if(response !== undefined){
			this.setState({ columns: response });
	  	}

		response = await lookupsOrderBy('REFOUND_PETITON_REASONS');
		if(response !== undefined){
			this.setState({
				returnReasons: response
			});
		}

		this.onSearch_send('inicial');
		this.onSearch_despatch('inicial');
	}

	showColumn(column_name){
      	for(var i =0; i < this.state.columns.length;i++){
  			if(this.state.columns[i]=== column_name){
          		return false;
        	}
      	}

	    return true;
  	}

	async onSearch_send(stat){
		this.props.waiting.handleShow("Cargando...");
		var response = await unitExportSearch(
						stat === undefined ? this.state.start_date : '', 
						stat === undefined ? this.state.end_date : '', 
						this.state.start_folio,
						this.state.end_folio,
						sessionStorage.getItem('health_facilities_id'),
						stat === undefined ? this.state.option : 'all'
					);
		if(response !== undefined){
			this.setState({
				results_send: response
			});
		}
	}

	async onSearch_despatch(stat){
		var response = await unitRequestSearch(
						stat === undefined ? this.state.start_date : '',
						stat === undefined ? this.state.end_date : '',
						this.state.start_folio,
						this.state.end_folio,
						stat === undefined ? this.state.option : 'ENVIADO',
						sessionStorage.getItem('health_facilities_id'),
						'requested_to',
						stat === undefined ? this.state.option : 'ENVIADO'
					);	
		if(response !== undefined){
			this.setState({
				results_despatch: response,
				show_label_btn:response.distribuidor_id !== sessionStorage.getItem('health_facilities_id')
			});
		}

		this.props.waiting.handleClose();
	}

	onSearch(){
		this.onSearch_send();
		this.onSearch_despatch();
	}

	filter(row){
		var res = true;

		if(row !== null){
			if(
				row.unit.id !== null &&
				row.unit.unit_number !== null &&
				row.blood_component.component !== null &&
				row.blood_component.code !== null &&
				row.unit.volume !== null &&
				row.status !== null
			){
				if(
					row.unit.id.toString().indexOf(this.state.filterText.toUpperCase()) !== -1 ||
					row.unit.unit_number.indexOf(this.state.filterText.toUpperCase()) !== -1 ||
					row.blood_component.component.indexOf(this.state.filterText.toUpperCase()) !== -1 ||
					row.blood_component.code.indexOf(this.state.filterText.toUpperCase()) !== -1 ||
					row.unit.component_number.indexOf(this.state.filterText.toUpperCase()) !== -1 ||
					row.unit.volume.indexOf(this.state.filterText.toUpperCase()) !== -1  ||
					row.status.indexOf(this.state.filterText.toUpperCase()) !== -1 
				){
					res = true;
				}else{
					res = false;
				}
			}

		}

		return res;
	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});

	}

	createShipping(){
		this.props.history.push("/shippings_despatch");
	}

	modalDetails(e,item){
		e.preventDefault();
    	this.modal_view_information.handleShow(item);
	}

	changeStatus(id){
		var options = '';
		this.state.returnReasons.map((r, j)=>(
			options += '<option value='+r.key+'>'+
							r.name+
						'</option>'
		));

		
		var content = "<div class='col-xs-12'>"+
			'<div class="col-xs-12"><span>¿Desea retirar el envío?</span></div>'+
			'<div class="col-xs-12 mensaje" style="padding-top:20px"></div>'+
			'<div class="col-xs-12" style="text-align:left;">'+
				'<span>Motivo</span><span> (*)</span>'+
				'<select class="form-control" id="reason_id" name="reason_id" required style="padding:0;">'+
					'<option value="">Seleccione...</option>'+
					options+
				'</select>'+
			'</div>'+
			'<div class="col-xs-12" style="text-align:left;">'+
				'<span>Observaciones</span>'+
				'<textarea rows="5" style="display:block;margin-top:0;font-size:11px;" id="observations" name="observations" class="form-control" ></textarea>'+
			'</div>'+
		'</div>';

		swal({
	        title: '¿Está seguro?',
	        text: content,
	        html: true,
	        type: 'warning',
	        showCancelButton: true,
	        confirmButtonColor: '#DD6B55',
	        confirmButtonText: '¡Si, Eliminar!',
	        cancelButtonText: '¡No, Cancelar!',
	        closeOnConfirm: this.state.closeConfirm,
	        closeOnCancel: true
	    }, async (isConfirm) =>{
	        if (isConfirm) {

				var reason = document.getElementById('reason_id').value;
	        	var observa = document.getElementById('observations').value;

	        	var valid = true;
	        	if(reason === ""){
	        		document.getElementById('reason_id').classList.add('error');
	        		valid = false;
					$('.mensaje').html('El motivo no puede estar vacio');
	        		this.setState({closeConfirm:false});
	        	}else{
	        		$('.mensaje').html('');
	        		document.getElementById('reason_id').classList.remove('error');
	        		valid = true;
	        		this.setState({closeConfirm:true});
	        	}

				if(observa.length >255){
					document.getElementById('observations').classList.add('error');
	        		valid = false;
					$('.mensaje').html('Longitud máxima para descripcion es de 255');
	        		this.setState({closeConfirm:false});
				}

				if(valid){
	        		var obj={
	        			return_reason:reason,
	        			return_observations:observa
	        		};

					var response = await unitExportDelete(id, obj, this.props.waiting);
					if(response){
						swal('Buen Trabajo', 'Solicitud Retirada','success');
						this.onSearch_send();
						this.onSearch_despatch();
					}else{
						this.setState({closeConfirm:false});
					}
	        		
				}
	        }
	    });
	}

	changeStatusDespatch(id){
		this.modal_status.handleShow(id);
	}

	async onPrint(id, tipo, e){
		e.preventDefault();

    	if(tipo === 'envio'){
    		var file_type = 'AREA_SEND_UNIT';
    		var file_template = "AREA_SEND_UNIT";
    	}else{
    		var file_type = 'AREA_DISTRIBUTION';
    		var file_template = "area_distribution";
    	}

		var response = await htmlTemplates(sessionStorage.getItem("health_facilities_id"), file_type);
		if(response !== undefined){
			if(response.res === 0){
				swal('¡Error!', "No se ha definido ningún formato de impresión", 'error');
			}else{
					this.waiting_modal.handleShow('Imprimiendo...');
			
				var obj ={};
				obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
				obj.id = id;
				obj.file_type = file_template;
				obj.nEtiqueta = [0];

				var type = await this.props.getDocumentType(obj.file_type);

				var document;
				if(type !== undefined){
					if(type.print_type === 'template'){
						document = await this.props.printDocumentTemplate(obj, type.print_automatically);
					}else if(type.print_type === 'external'){
						document = await this.props.printDocumentExternal(obj, type.print_automatically);
					}
				}				

				if(document !== undefined){
					this.waiting_modal.handleClose();
					this.setState({ show: false});
				}else{
					this.waiting_modal.handleClose();
				}
					
			}
		}
  	}

  	validateInput(e) {
	    const re = /^[-+]?$/;

	    if (e.key === "Enter") {
      		e.preventDefault(); // Prevent form submission if button present
      		
      		const form = e.target.form;
      		const index = Array.prototype.indexOf.call(form, e.target);

      		if(form.elements[index + 1] !== undefined)
    			form.elements[index + 1].focus();
    	
		    if (!re.test(e.key)) {
		      e.preventDefault();
		    }
		}
  	}

  	editUnitOrder(id){
		this.props.history.push("distribution/despatch/"+id);
	}

	viewDetails(title, id){
		this.modal_view.handleShow(title, id);
	}

	openReport(id, tipo, e){
		this.props.history.push('/Shippings/report/'+tipo+'/'+id);
	}

	editShipping(id){
		this.props.history.push('shippings/edit/'+id);
	}

	handleUserInput(filterText) {
		this.setState({filterText: filterText});
	};
	
	filter(row){ 
		var res = true;
	
		if(row !== undefined){

			if(//Buscar en offer
				(row.unit_export !== undefined ?
					row.unit_export.folio.indexOf(this.state.filterText.toUpperCase()) !== -1
				: false)	 ||
				row.request_to.name.indexOf(this.state.filterText.toUpperCase())!==-1 ||
				row.components.indexOf(this.state.filterText.toUpperCase())!==-1 ||
				row.amount.toString().indexOf(this.state.filterText.toUpperCase())!==-1 ||
				row.user.indexOf(this.state.filterText) !== -1 ||
				(row.unit_export !== undefined ? row.unit_export.status.indexOf(this.state.filterText.toUpperCase()) !== -1 : false)
			){
				res=true;
			}else{
				res = false;
			}
		}
		return res
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.distribution.MAIN')} ->
						Envío de unidades
					</h5>
				</div>

				<Help 
					{...this.props}
	                menu={"help_distribution"} 
	                submenu={"help_unit_export"}  />
	                
				<form noValidate>
					<div className="col-xs-12 form-group" style={{paddingLeft:"0px"}}>
						<div className="col-xs-12 col-sm-2">
							<span className="span-min">Fecha Desde</span>
							<input className="form-control" type="date" name="start_date" id="start_date"
								onKeyPress={(e) => this.validateInput(e)} 
								onChange={this.handleChange} value={this.state.start_date || ""} autoFocus={true} />
						</div>
						<div className="col-xs-12 col-sm-2">
							<span className="span-min">Fecha Hasta</span>
							<input className="form-control" type="date" name="end_date" id="end_date" 
								onKeyPress={(e) => this.validateInput(e)}
								onChange={this.handleChange} value={this.state.end_date || ""}  />
						</div>
						<div className={"col-xs-12 col-sm-2"}>
							<span className="span-min">Folio Desde</span>
							<input className="form-control" type="text" name="start_folio" id="start_folio" 
								onKeyPress={(e) => this.validateInput(e)}
								onChange={this.handleChange} value={this.state.start_folio || ""} />
						</div>
						<div className={"col-xs-12 col-sm-2"}>
							<span className="span-min">Folio Hasta</span>
							<input className="form-control" type="text" name="end_folio" id="end_folio"
								onKeyPress={(e) => this.validateInput(e)} 
								onChange={this.handleChange} value={this.state.end_folio || ""} />
						</div>
						<div className={"col-xs-12 col-sm-2"}>
							<span className="span-min">Estatus</span>
							<select name="option" id="option" value={this.state.option || ""} 
								onKeyPress={(e) => this.validateInput(e)}
								onChange={this.handleChange}
								className="form-control">
								<option value="all">TODOS</option>
								<option value="PENDIENTE">PENDIENTE</option>
								<option value="ENVIADO">SOLICITADO</option>
								<option value="RECHAZADA">RECHAZADA</option>
								<option value="SUMINISTRADO">SUMINISTRADO</option>
							</select>
						</div>
						<div className="col-xs-12 col-sm-2" style={{marginTop:"10.5px"}}>
							<Button className="btn btn-info" title="Buscar" style={{fontSize:"1em",marginRight:"5px"}} 
								onClick={this.onSearch}>
								Buscar
							</Button>
							<Button className="btn btn-info" title="Nuevo" style={{fontSize:"1em"}} 
								disabled={!this.props.task_unit_send.create}
								onClick={this.createShipping.bind(this)}>
								Nuevo
							</Button>
						</div>
					</div>
				</form>

				<div className="col-xs-12 col-md-2" style={{marginTop:"5px",marginBottom:"5px"}}>
					<SearchBar filterText={this.state.filterText} onUserInput={this.handleUserInput.bind(this)}/>
				</div>
				<div className="col-xs-12">
					<Table responsive hover>
						<thead>
							<tr>
								<th hidden={this.showColumn('TYPE')}>Tipo Destino</th>
								<th>Folio del Pedido</th>
								<th hidden={this.showColumn('FOLIO')}>Folio del Envío</th>
								<th hidden={this.showColumn('SENT_TO')}>Enviado a</th>
								<th hidden={this.showColumn('COMPONENTS')}>Componentes</th>
								<th hidden={this.showColumn('AMOUNT')}>Cant. Tot.</th>
								<th hidden={this.showColumn('RETURNED')}>Devueltas</th>
								<th hidden={this.showColumn('SEND_BY')}>Enviado por</th>
								<th hidden={this.showColumn('DATE')}>Fecha y Hora</th>
								<th hidden={this.showColumn('STATUS')}>Estatus</th>
								<th hidden={this.showColumn('CONTROLS')} style={{width:"185px"}}></th>
							</tr>
						</thead>

						<tbody>
		                 	{this.state.results_send.map( (item, index) => (
								this.filter(item) === true? 
			                    <tr key={item.unit_export.id}>
			                    	<td hidden={this.showColumn('TYPE')}>Externos</td>
									<td></td>
			                      	<td hidden={this.showColumn('FOLIO')}>{item.unit_export.folio}</td>
									<td hidden={this.showColumn('SENT_TO')}>{item.request_to.name}</td>
									<td hidden={this.showColumn('COMPONENTS')}>{item.components}</td>
									<td hidden={this.showColumn('AMOUNT')}>{item.amount}</td>
									<td hidden={this.showColumn('RETURNED')}>{item.returned}</td>
									<td hidden={this.showColumn('SEND_BY')}>{item.user}</td>
									<td hidden={this.showColumn('DATE')}>
										<Moment format="DD/MM/YYYY">{item.unit_export.date}</Moment> - 
										{moment(item.unit_export.hour, 'H:mm:ss.sssssss').format('HH:mm')}</td>
									<td hidden={this.showColumn('STATUS')}>{item.unit_export.status}</td>
									<td hidden={this.showColumn('CONTROLS')} style={{width:"185px"}}>
										<Button className="btn btn-info btn-xs" title="Ver" style={{marginRight:"5px"}} 
											onClick={(e)=>this.modalDetails(e,item)}>
											<SvgIcon icon={search} />
										</Button>

										<Button className="btn btn-info btn-xs" title="Imprimir" style={{marginRight:"5px"}}
											/*onClick={(e)=>this.onPrint(item.unit_export.id, 'envio', e)}*/
											disabled={item.unit_export.status === 'CANCELADO'}
											onClick={(e)=>this.openReport(item.unit_export.id, 'envio', e)}>
											<SvgIcon icon={print} />
										</Button>

										{item.unit_export.status==="SUMINISTRADO"?
											<Button className="btn btn-info btn-xs" title="Editar" style={{marginRight:"5px"}} 
												onClick={this.editShipping.bind(this,item.unit_export.id)}
												disabled={item.unit_export.status !== 'ENVIADO' || !this.props.task_unit_send.update}
												>
												<SvgIcon icon={pencil2} />
											</Button>
										: null}
										{this.props.task_unit_send.delete ?
											item.unit_export.status!=="CANCELADO"?
												<Button className="btn btn-info btn-xs" title="Eliminar" style={{marginRight:"5px"}}
													onClick={this.changeStatus.bind(this,item.unit_export.id)}>
													<SvgIcon icon={cross} />
												</Button>
											:null
										:null}
									</td>
			                    </tr>
								:null
		                    ))}

		                    {this.state.results_despatch.map( (item, index) => (
								this.filter(item) === true? 
			                    <tr key={item.unit_request.id}>
			                    	<td hidden={this.showColumn('TYPE')}>Hemored</td>
			                      	<td hidden={this.showColumn('FOLIO')}>{item.unit_request.id}</td>
									<td>{item.unit_request.folio}</td>
									<td hidden={this.showColumn('SENT_TO')}>{item.request_to.name}</td>
									<td hidden={this.showColumn('COMPONENTS')}>{item.components}</td>
									<td hidden={this.showColumn('AMOUNT')}>{item.amount}</td>
									<td hidden={this.showColumn('RETURNED')}>{item.returned}</td>
									<td hidden={this.showColumn('SEND_BY')}>{item.user}</td>
									<td hidden={this.showColumn('DATE')}>
										<Moment format="DD/MM/YYYY">{item.unit_request.date}</Moment> - 
										{moment(item.unit_request.hour, 'H:mm:ss.sssssss').format('HH:mm')}
									</td>
									<td hidden={this.showColumn('STATUS')}>{item.status==="ENVIADO"?"SOLICITADO":item.status}</td>
									<td hidden={this.showColumn('CONTROLS')} style={{width:"185px"}}>
										<Button className="btn btn-info btn-xs" title="Ver" style={{marginRight:"5px"}}
											onClick={this.viewDetails.bind(this,'Despacho de Unidades', item.unit_request.id)}>
											<SvgIcon icon={search} />
										</Button>
										<Button className="btn btn-info btn-xs" title="Imprimir" style={{marginRight:"5px"}}
											/*onClick={(e)=>this.onPrint(item.unit_request.id, 'despacho', e)}*/
											disabled={item.status === 'CANCELADO'}
											onClick={(e)=>this.openReport(item.unit_request.id, 'despacho', e)}>
											<SvgIcon icon={print} />
										</Button>
										<Button className="btn btn-info btn-xs" title="Editar" style={{marginRight:"5px"}} 
											onClick={this.editUnitOrder.bind(this,item.unit_request.id)}
											disabled={this.props.task_unit_send.update ?
														item.status !== 'ENVIADO' ? true : false
													: false}>
											<SvgIcon icon={pencil2} />
										</Button>
										<Button className="btn btn-info btn-xs" title="Confirmar" style={{marginRight:"5px"}}
											disabled>
											<SvgIcon icon={download3} />
										</Button>
										<Button className="btn btn-info btn-xs" title="Retirar" style={{marginRight:"5px"}}
											disabled={item.status !== 'ENVIADO' || !this.props.task_unit_send.delete}
											onClick={this.changeStatusDespatch.bind(this,item.unit_request.id)}>
											<SvgIcon icon={cross} />
										</Button>
									</td>
			                    </tr>
								:null
		                    ))}
		                </tbody>
					</Table>
				</div>

				<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
				<ModalShippingDetails {...this.props} onRef={ref => (this.modal_view_information = ref)} refresh={this.props.refresh} />
				<ModalView {...this.props} onRef={ref => (this.modal_view = ref)}/>
				<ModalStatus {...this.props} onSearch_despatch={this.onSearch_despatch} 
				 	onSearch_send={this.onSearch_send} onRef={ref => (this.modal_status = ref)}/>
			</div>
		)
	}
}

export default translate('translations')(Shippings)

